import { section } from "@/neon";

import scrollIntoView from "@/lib/scrollIntoView";

const selectors = {
  overlay: ".video__overlay",
  player: ".video__player",
  button: "[data-video-trigger]",
  wrapper: ".video__wrapper",
};

section("video", {
  videoType: null,
  videoPlayer: null,

  onLoad() {
    this._initPlayer();

    this.scrollAnimation = scrollIntoView(this.container);
  },

  _initPlayer() {
    import(flu.chunks.video).then(({ Video }) => {
      const { videoId, videoType } = this.container.dataset;

      if (!videoId || !videoType) return;

      const overlay = this.container.querySelector(selectors.overlay);
      const player = this.container.querySelector(selectors.player);
      this.button = this.container.querySelector(selectors.button);

      this.video = Video(this.container, {
        id: videoId,
        type: videoType,
        playerEl: player,
      });

      this.video.on("play", () => {
        overlay.classList.remove("visible");
      });

      this.button &&
        this.button.addEventListener("click", this._playVideo.bind(this));
    });
  },

  _playVideo(e) {
    e.preventDefault();

    this.video.play();
  },

  onUnload() {
    this.video && this.video.destroy();
    this.button && this.button.removeEventListener("click", this.video.play);
    this.scrollAnimation.unload();
  },
});
